/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  BadRequestException,
  BTFileViewer,
  CopySelectionOptionsRequest,
  CopySelectionOptionsResponse,
  MassEditOptionsResponse,
  MassUpdateRequest,
  MassUpdateResponse,
  ProblemDetails,
  SearchAllowanceLibraryResponse,
  SearchSelectionOptionLibraryResponse,
  SelectionOptionCreationRequest,
  SelectionOptionDefaultsResponse,
  SelectionOptionParseDocumentsRequest,
  SelectionOptionParseDocumentsResponse,
  SelectionOptionParseRequest,
  SelectionOptionParseUrlResponse,
  SelectionOptionResponse,
  SelectionOptionsAllowanceLibraryGetV2Params,
  SelectionOptionsAttachmentsBySelectionOptionIdGetV2Params,
  SelectionOptionsBuilderLibraryGetV2Params,
  SelectionOptionsBySelectionOptionIdDeleteV2Params,
  SelectionOptionsBySelectionOptionIdGetV2Params,
  SelectionOptionsGetV2Params,
  SelectionOptionsImportResponse,
  SelectionOptionsImportSelectionsFromFilePostV2Body,
  SelectionOptionsMassDeleteRequest,
  SelectionOptionsMassDeleteResponse,
  SelectionOptionsSelectionOptionsMassEditGetV2Params,
  SelectionOptionsStatusUpdateRequest,
  SelectionOptionsStatusUpdateResponse,
  SelectionOptionUpdateRequest,
  SelectionsListResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Copies one or more selection options within a job, duplicating their line items,
cost types, attachments, and spec links. Returns both successful copies and any
option failures.
 */
export const selectionOptionsCopyOptionsPostV2 = (
  copySelectionOptionsRequest: BodyType<CopySelectionOptionsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CopySelectionOptionsResponse>(
    {
      url: `/apix/v2/SelectionOptions/copy-options`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: copySelectionOptionsRequest,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsCopyOptionsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>,
    TError,
    { data: BodyType<CopySelectionOptionsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>,
  TError,
  { data: BodyType<CopySelectionOptionsRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsCopyOptionsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>,
    { data: BodyType<CopySelectionOptionsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsCopyOptionsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsCopyOptionsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>
>;
export type SelectionOptionsCopyOptionsPostV2MutationBody =
  BodyType<CopySelectionOptionsRequest>;
export type SelectionOptionsCopyOptionsPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Copies one or more selection options within a job, duplicating their line items,
cost types, attachments, and spec links. Returns both successful copies and any
option failures.
 */
export const useSelectionOptionsCopyOptionsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>,
    TError,
    { data: BodyType<CopySelectionOptionsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsCopyOptionsPostV2>>,
  TError,
  { data: BodyType<CopySelectionOptionsRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsCopyOptionsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Imports Selection Options from an uploaded Excel or CSV file into the given job.
 */
export const selectionOptionsImportSelectionsFromFilePostV2 = (
  selectionOptionsImportSelectionsFromFilePostV2Body: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (selectionOptionsImportSelectionsFromFilePostV2Body.file !== undefined) {
    formData.append(
      `file`,
      selectionOptionsImportSelectionsFromFilePostV2Body.file,
    );
  }
  if (selectionOptionsImportSelectionsFromFilePostV2Body.jobId !== undefined) {
    formData.append(
      `jobId`,
      selectionOptionsImportSelectionsFromFilePostV2Body.jobId.toString(),
    );
  }

  return apixHandler<SelectionOptionsImportResponse>(
    {
      url: `/apix/v2/SelectionOptions/import-selections-from-file`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsImportSelectionsFromFilePostV2MutationOptions =
  <
    TError = ErrorType<BadRequestException | ProblemDetails>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>
      >,
      TError,
      { data: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>>,
    TError,
    { data: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body> },
    TContext
  > => {
    const mutationKey = ["selectionOptionsImportSelectionsFromFilePostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>
      >,
      { data: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body> }
    > = (props) => {
      const { data } = props ?? {};

      return selectionOptionsImportSelectionsFromFilePostV2(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SelectionOptionsImportSelectionsFromFilePostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>>
  >;
export type SelectionOptionsImportSelectionsFromFilePostV2MutationBody =
  BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body>;
export type SelectionOptionsImportSelectionsFromFilePostV2MutationError =
  ErrorType<BadRequestException | ProblemDetails>;

/**
 * @summary Imports Selection Options from an uploaded Excel or CSV file into the given job.
 */
export const useSelectionOptionsImportSelectionsFromFilePostV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>>,
    TError,
    { data: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsImportSelectionsFromFilePostV2>>,
  TError,
  { data: BodyType<SelectionOptionsImportSelectionsFromFilePostV2Body> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsImportSelectionsFromFilePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Creates a selection option
 */
export const selectionOptionsCreateOptionPostV2 = (
  selectionOptionCreationRequest: BodyType<SelectionOptionCreationRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionOptionResponse>(
    {
      url: `/apix/v2/SelectionOptions/create-option`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionCreationRequest,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsCreateOptionPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>,
    TError,
    { data: BodyType<SelectionOptionCreationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>,
  TError,
  { data: BodyType<SelectionOptionCreationRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsCreateOptionPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>,
    { data: BodyType<SelectionOptionCreationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsCreateOptionPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsCreateOptionPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>
>;
export type SelectionOptionsCreateOptionPostV2MutationBody =
  BodyType<SelectionOptionCreationRequest>;
export type SelectionOptionsCreateOptionPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Creates a selection option
 */
export const useSelectionOptionsCreateOptionPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>,
    TError,
    { data: BodyType<SelectionOptionCreationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsCreateOptionPostV2>>,
  TError,
  { data: BodyType<SelectionOptionCreationRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsCreateOptionPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Parses one or more product URLs via the BT AI service and returns the extracted
selection option fields (title, description, unit, price, imageurl) per URL. Each URL
returns its own result row (success or failure)
 */
export const selectionOptionsParseFromUrlsPostV2 = (
  selectionOptionParseRequest: BodyType<SelectionOptionParseRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionOptionParseUrlResponse>(
    {
      url: `/apix/v2/SelectionOptions/parse-from-urls`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionParseRequest,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsParseFromUrlsPostV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>,
    TError,
    { data: BodyType<SelectionOptionParseRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>,
  TError,
  { data: BodyType<SelectionOptionParseRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsParseFromUrlsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>,
    { data: BodyType<SelectionOptionParseRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsParseFromUrlsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsParseFromUrlsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>
>;
export type SelectionOptionsParseFromUrlsPostV2MutationBody =
  BodyType<SelectionOptionParseRequest>;
export type SelectionOptionsParseFromUrlsPostV2MutationError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Parses one or more product URLs via the BT AI service and returns the extracted
selection option fields (title, description, unit, price, imageurl) per URL. Each URL
returns its own result row (success or failure)
 */
export const useSelectionOptionsParseFromUrlsPostV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>,
    TError,
    { data: BodyType<SelectionOptionParseRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsParseFromUrlsPostV2>>,
  TError,
  { data: BodyType<SelectionOptionParseRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsParseFromUrlsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Parses a document from the GCS temp bucket via BTNet-AI and returns field suggestions
(title, description, line items) for pre-populating selection option fields.
Requires the SelectionOptionDocumentScraping feature flag.
 */
export const selectionOptionsParseDocumentsPostV2 = (
  selectionOptionParseDocumentsRequest: BodyType<SelectionOptionParseDocumentsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionOptionParseDocumentsResponse>(
    {
      url: `/apix/v2/SelectionOptions/parse-documents`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionParseDocumentsRequest,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsParseDocumentsPostV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>,
    TError,
    { data: BodyType<SelectionOptionParseDocumentsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>,
  TError,
  { data: BodyType<SelectionOptionParseDocumentsRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsParseDocumentsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>,
    { data: BodyType<SelectionOptionParseDocumentsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsParseDocumentsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsParseDocumentsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>
>;
export type SelectionOptionsParseDocumentsPostV2MutationBody =
  BodyType<SelectionOptionParseDocumentsRequest>;
export type SelectionOptionsParseDocumentsPostV2MutationError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Parses a document from the GCS temp bucket via BTNet-AI and returns field suggestions
(title, description, line items) for pre-populating selection option fields.
Requires the SelectionOptionDocumentScraping feature flag.
 */
export const useSelectionOptionsParseDocumentsPostV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>,
    TError,
    { data: BodyType<SelectionOptionParseDocumentsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsParseDocumentsPostV2>>,
  TError,
  { data: BodyType<SelectionOptionParseDocumentsRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsParseDocumentsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets attachments for a selection option based on jobId and selectionOptionID
 */
export const selectionOptionsAttachmentsBySelectionOptionIdGetV2 = (
  selectionOptionId: number,
  params?: SelectionOptionsAttachmentsBySelectionOptionIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BTFileViewer>(
    {
      url: `/apix/v2/SelectionOptions/${selectionOptionId}/attachments`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryKey = (
  selectionOptionId?: number,
  params?: SelectionOptionsAttachmentsBySelectionOptionIdGetV2Params,
) => {
  return [
    `/apix/v2/SelectionOptions/${selectionOptionId}/attachments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
    >,
    TError = ErrorType<unknown>,
  >(
    selectionOptionId: number,
    params?: SelectionOptionsAttachmentsBySelectionOptionIdGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryKey(
        selectionOptionId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
      >
    > = ({ signal }) =>
      selectionOptionsAttachmentsBySelectionOptionIdGetV2(
        selectionOptionId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!selectionOptionId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
    >
  >;
export type SelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets attachments for a selection option based on jobId and selectionOptionID
 */

export function useSelectionOptionsAttachmentsBySelectionOptionIdGetV2<
  TData = Awaited<
    ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  selectionOptionId: number,
  params?: SelectionOptionsAttachmentsBySelectionOptionIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof selectionOptionsAttachmentsBySelectionOptionIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSelectionOptionsAttachmentsBySelectionOptionIdGetV2QueryOptions(
      selectionOptionId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets a selection option based on jobId and selectionOptionID
 */
export const selectionOptionsBySelectionOptionIdGetV2 = (
  selectionOptionId: number,
  params?: SelectionOptionsBySelectionOptionIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionOptionResponse>(
    {
      url: `/apix/v2/SelectionOptions/${selectionOptionId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsBySelectionOptionIdGetV2QueryKey = (
  selectionOptionId?: number,
  params?: SelectionOptionsBySelectionOptionIdGetV2Params,
) => {
  return [
    `/apix/v2/SelectionOptions/${selectionOptionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectionOptionsBySelectionOptionIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  selectionOptionId: number,
  params?: SelectionOptionsBySelectionOptionIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSelectionOptionsBySelectionOptionIdGetV2QueryKey(
      selectionOptionId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>
  > = ({ signal }) =>
    selectionOptionsBySelectionOptionIdGetV2(
      selectionOptionId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!selectionOptionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionOptionsBySelectionOptionIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>
>;
export type SelectionOptionsBySelectionOptionIdGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets a selection option based on jobId and selectionOptionID
 */

export function useSelectionOptionsBySelectionOptionIdGetV2<
  TData = Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  selectionOptionId: number,
  params?: SelectionOptionsBySelectionOptionIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSelectionOptionsBySelectionOptionIdGetV2QueryOptions(
    selectionOptionId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Delete selection option based on jobId and selectionOptionId
 */
export const selectionOptionsBySelectionOptionIdDeleteV2 = (
  selectionOptionId: number,
  params?: SelectionOptionsBySelectionOptionIdDeleteV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/SelectionOptions/${selectionOptionId}`,
      method: "DELETE",
      params,
    },
    options,
  );
};

export const getSelectionOptionsBySelectionOptionIdDeleteV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>,
    TError,
    {
      selectionOptionId: number;
      params?: SelectionOptionsBySelectionOptionIdDeleteV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>,
  TError,
  {
    selectionOptionId: number;
    params?: SelectionOptionsBySelectionOptionIdDeleteV2Params;
  },
  TContext
> => {
  const mutationKey = ["selectionOptionsBySelectionOptionIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>,
    {
      selectionOptionId: number;
      params?: SelectionOptionsBySelectionOptionIdDeleteV2Params;
    }
  > = (props) => {
    const { selectionOptionId, params } = props ?? {};

    return selectionOptionsBySelectionOptionIdDeleteV2(
      selectionOptionId,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsBySelectionOptionIdDeleteV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>
  >;

export type SelectionOptionsBySelectionOptionIdDeleteV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Delete selection option based on jobId and selectionOptionId
 */
export const useSelectionOptionsBySelectionOptionIdDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>,
    TError,
    {
      selectionOptionId: number;
      params?: SelectionOptionsBySelectionOptionIdDeleteV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdDeleteV2>>,
  TError,
  {
    selectionOptionId: number;
    params?: SelectionOptionsBySelectionOptionIdDeleteV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsBySelectionOptionIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Updates a selection option based on selectionOptionId
 */
export const selectionOptionsBySelectionOptionIdPutV2 = (
  selectionOptionId: number,
  selectionOptionUpdateRequest: BodyType<SelectionOptionUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionResponse>(
    {
      url: `/apix/v2/SelectionOptions/${selectionOptionId}`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsBySelectionOptionIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>,
    TError,
    { selectionOptionId: number; data: BodyType<SelectionOptionUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>,
  TError,
  { selectionOptionId: number; data: BodyType<SelectionOptionUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsBySelectionOptionIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>,
    { selectionOptionId: number; data: BodyType<SelectionOptionUpdateRequest> }
  > = (props) => {
    const { selectionOptionId, data } = props ?? {};

    return selectionOptionsBySelectionOptionIdPutV2(
      selectionOptionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsBySelectionOptionIdPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>
  >;
export type SelectionOptionsBySelectionOptionIdPutV2MutationBody =
  BodyType<SelectionOptionUpdateRequest>;
export type SelectionOptionsBySelectionOptionIdPutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Updates a selection option based on selectionOptionId
 */
export const useSelectionOptionsBySelectionOptionIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>,
    TError,
    { selectionOptionId: number; data: BodyType<SelectionOptionUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsBySelectionOptionIdPutV2>>,
  TError,
  { selectionOptionId: number; data: BodyType<SelectionOptionUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsBySelectionOptionIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets line item defaults and selection option groups for a specific job
 */
export const selectionOptionsSelectionOptionDefaultsByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionOptionDefaultsResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-option-defaults/${jobId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [
    `/apix/v2/SelectionOptions/selection-option-defaults/${jobId}`,
  ] as const;
};

export const getSelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
    >,
    TError = ErrorType<unknown>,
  >(
    jobId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryKey(jobId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
      >
    > = ({ signal }) =>
      selectionOptionsSelectionOptionDefaultsByJobIdGetV2(
        jobId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
    >
  >;
export type SelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets line item defaults and selection option groups for a specific job
 */

export function useSelectionOptionsSelectionOptionDefaultsByJobIdGetV2<
  TData = Awaited<
    ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof selectionOptionsSelectionOptionDefaultsByJobIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSelectionOptionsSelectionOptionDefaultsByJobIdGetV2QueryOptions(
      jobId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets all selections needed for a specific job based on jobId
This includes: selection options and selection option groups associated with an estimate line item (allowances)
SelectionOptionGroups not associated with an estimate line item will come later
 */
export const selectionOptionsGetV2 = (
  params?: SelectionOptionsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionsListResponse>(
    { url: `/apix/v2/SelectionOptions`, method: "GET", params, signal },
    options,
  );
};

export const getSelectionOptionsGetV2QueryKey = (
  params?: SelectionOptionsGetV2Params,
) => {
  return [`/apix/v2/SelectionOptions`, ...(params ? [params] : [])] as const;
};

export const getSelectionOptionsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof selectionOptionsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SelectionOptionsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSelectionOptionsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionOptionsGetV2>>
  > = ({ signal }) => selectionOptionsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionOptionsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionOptionsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsGetV2>>
>;
export type SelectionOptionsGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets all selections needed for a specific job based on jobId
This includes: selection options and selection option groups associated with an estimate line item (allowances)
SelectionOptionGroups not associated with an estimate line item will come later
 */

export function useSelectionOptionsGetV2<
  TData = Awaited<ReturnType<typeof selectionOptionsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SelectionOptionsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSelectionOptionsGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Searches allowances across all jobs for the current builder, excluding the target job.
 */
export const selectionOptionsAllowanceLibraryGetV2 = (
  params?: SelectionOptionsAllowanceLibraryGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SearchAllowanceLibraryResponse>(
    {
      url: `/apix/v2/SelectionOptions/allowance-library`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsAllowanceLibraryGetV2QueryKey = (
  params?: SelectionOptionsAllowanceLibraryGetV2Params,
) => {
  return [
    `/apix/v2/SelectionOptions/allowance-library`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectionOptionsAllowanceLibraryGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: SelectionOptionsAllowanceLibraryGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSelectionOptionsAllowanceLibraryGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>
  > = ({ signal }) =>
    selectionOptionsAllowanceLibraryGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionOptionsAllowanceLibraryGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>
>;
export type SelectionOptionsAllowanceLibraryGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Searches allowances across all jobs for the current builder, excluding the target job.
 */

export function useSelectionOptionsAllowanceLibraryGetV2<
  TData = Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: SelectionOptionsAllowanceLibraryGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsAllowanceLibraryGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSelectionOptionsAllowanceLibraryGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Returns the list of fields that can be mass-edited on a selection of selection options
(Category, Location). Used by the front-end MassEntityEdit component to populate its
field picker.
 */
export const selectionOptionsSelectionOptionsMassEditGetV2 = (
  params?: SelectionOptionsSelectionOptionsMassEditGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassEditOptionsResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/mass-edit`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsMassEditGetV2QueryKey = (
  params?: SelectionOptionsSelectionOptionsMassEditGetV2Params,
) => {
  return [
    `/apix/v2/SelectionOptions/selection-options/mass-edit`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectionOptionsSelectionOptionsMassEditGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>
  >,
  TError = ErrorType<BadRequestException | ProblemDetails>,
>(
  params?: SelectionOptionsSelectionOptionsMassEditGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSelectionOptionsSelectionOptionsMassEditGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>>
  > = ({ signal }) =>
    selectionOptionsSelectionOptionsMassEditGetV2(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionOptionsSelectionOptionsMassEditGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>>
  >;
export type SelectionOptionsSelectionOptionsMassEditGetV2QueryError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Returns the list of fields that can be mass-edited on a selection of selection options
(Category, Location). Used by the front-end MassEntityEdit component to populate its
field picker.
 */

export function useSelectionOptionsSelectionOptionsMassEditGetV2<
  TData = Awaited<
    ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>
  >,
  TError = ErrorType<BadRequestException | ProblemDetails>,
>(
  params?: SelectionOptionsSelectionOptionsMassEditGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSelectionOptionsSelectionOptionsMassEditGetV2QueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Bulk-updates one or more fields (Category, Location) on a set of selection options.
All option IDs must belong to the same Selections Reimagined job for the current builder.
 */
export const selectionOptionsSelectionOptionsMassEditPutV2 = (
  massUpdateRequest: BodyType<MassUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<MassUpdateResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/mass-edit`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsMassEditPutV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>,
    TError,
    { data: BodyType<MassUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>,
  TError,
  { data: BodyType<MassUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsSelectionOptionsMassEditPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>,
    { data: BodyType<MassUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsSelectionOptionsMassEditPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsSelectionOptionsMassEditPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>
  >;
export type SelectionOptionsSelectionOptionsMassEditPutV2MutationBody =
  BodyType<MassUpdateRequest>;
export type SelectionOptionsSelectionOptionsMassEditPutV2MutationError =
  ErrorType<BadRequestException | ProblemDetails>;

/**
 * @summary Bulk-updates one or more fields (Category, Location) on a set of selection options.
All option IDs must belong to the same Selections Reimagined job for the current builder.
 */
export const useSelectionOptionsSelectionOptionsMassEditPutV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>,
    TError,
    { data: BodyType<MassUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsMassEditPutV2>>,
  TError,
  { data: BodyType<MassUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsMassEditPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Searches selection options across all jobs for the current builder.
 */
export const selectionOptionsBuilderLibraryGetV2 = (
  params?: SelectionOptionsBuilderLibraryGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SearchSelectionOptionLibraryResponse>(
    {
      url: `/apix/v2/SelectionOptions/builder-library`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSelectionOptionsBuilderLibraryGetV2QueryKey = (
  params?: SelectionOptionsBuilderLibraryGetV2Params,
) => {
  return [
    `/apix/v2/SelectionOptions/builder-library`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectionOptionsBuilderLibraryGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: SelectionOptionsBuilderLibraryGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSelectionOptionsBuilderLibraryGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>
  > = ({ signal }) =>
    selectionOptionsBuilderLibraryGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionOptionsBuilderLibraryGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>
>;
export type SelectionOptionsBuilderLibraryGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Searches selection options across all jobs for the current builder.
 */

export function useSelectionOptionsBuilderLibraryGetV2<
  TData = Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: SelectionOptionsBuilderLibraryGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionOptionsBuilderLibraryGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSelectionOptionsBuilderLibraryGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Soft deletes multiple selection options for a job in a single call
 */
export const selectionOptionsSelectionOptionsMassDeleteDeleteV2 = (
  selectionOptionsMassDeleteRequest: BodyType<SelectionOptionsMassDeleteRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionsMassDeleteResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/mass-delete`,
      method: "DELETE",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionsMassDeleteRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsMassDeleteDeleteV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
      >,
      TError,
      { data: BodyType<SelectionOptionsMassDeleteRequest> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
    >,
    TError,
    { data: BodyType<SelectionOptionsMassDeleteRequest> },
    TContext
  > => {
    const mutationKey = ["selectionOptionsSelectionOptionsMassDeleteDeleteV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
      >,
      { data: BodyType<SelectionOptionsMassDeleteRequest> }
    > = (props) => {
      const { data } = props ?? {};

      return selectionOptionsSelectionOptionsMassDeleteDeleteV2(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SelectionOptionsSelectionOptionsMassDeleteDeleteV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
    >
  >;
export type SelectionOptionsSelectionOptionsMassDeleteDeleteV2MutationBody =
  BodyType<SelectionOptionsMassDeleteRequest>;
export type SelectionOptionsSelectionOptionsMassDeleteDeleteV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Soft deletes multiple selection options for a job in a single call
 */
export const useSelectionOptionsSelectionOptionsMassDeleteDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
    >,
    TError,
    { data: BodyType<SelectionOptionsMassDeleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof selectionOptionsSelectionOptionsMassDeleteDeleteV2>
  >,
  TError,
  { data: BodyType<SelectionOptionsMassDeleteRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsMassDeleteDeleteV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Updates a list of selection options to have an APPROVED status
 */
export const selectionOptionsSelectionOptionsApprovePutV2 = (
  selectionOptionsStatusUpdateRequest: BodyType<SelectionOptionsStatusUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionsStatusUpdateResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/approve`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionsStatusUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsApprovePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsSelectionOptionsApprovePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsSelectionOptionsApprovePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsSelectionOptionsApprovePutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>
  >;
export type SelectionOptionsSelectionOptionsApprovePutV2MutationBody =
  BodyType<SelectionOptionsStatusUpdateRequest>;
export type SelectionOptionsSelectionOptionsApprovePutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Updates a list of selection options to have an APPROVED status
 */
export const useSelectionOptionsSelectionOptionsApprovePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsApprovePutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsApprovePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Updates a list of selection options to have a DECLINED status
 */
export const selectionOptionsSelectionOptionsDeclinePutV2 = (
  selectionOptionsStatusUpdateRequest: BodyType<SelectionOptionsStatusUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionsStatusUpdateResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/decline`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionsStatusUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsDeclinePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsSelectionOptionsDeclinePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsSelectionOptionsDeclinePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsSelectionOptionsDeclinePutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>
  >;
export type SelectionOptionsSelectionOptionsDeclinePutV2MutationBody =
  BodyType<SelectionOptionsStatusUpdateRequest>;
export type SelectionOptionsSelectionOptionsDeclinePutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Updates a list of selection options to have a DECLINED status
 */
export const useSelectionOptionsSelectionOptionsDeclinePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsDeclinePutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsDeclinePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Resets a list of selection options to have a PENDING status.
This operation sets approval-related fields (ApprovalDate, ApprovalByID, ApprovalByName) to track who performed the reset and when.
 */
export const selectionOptionsSelectionOptionsResetPutV2 = (
  selectionOptionsStatusUpdateRequest: BodyType<SelectionOptionsStatusUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionsStatusUpdateResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/reset`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionsStatusUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsResetPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsSelectionOptionsResetPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsSelectionOptionsResetPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsSelectionOptionsResetPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>
  >;
export type SelectionOptionsSelectionOptionsResetPutV2MutationBody =
  BodyType<SelectionOptionsStatusUpdateRequest>;
export type SelectionOptionsSelectionOptionsResetPutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Resets a list of selection options to have a PENDING status.
This operation sets approval-related fields (ApprovalDate, ApprovalByID, ApprovalByName) to track who performed the reset and when.
 */
export const useSelectionOptionsSelectionOptionsResetPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsResetPutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsResetPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Sends a list of draft selection options by transitioning them to PENDING (displayed as "Sent"),
making the options visible to clients in the client portal.
 */
export const selectionOptionsSelectionOptionsSendPutV2 = (
  selectionOptionsStatusUpdateRequest: BodyType<SelectionOptionsStatusUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionOptionsStatusUpdateResponse>(
    {
      url: `/apix/v2/SelectionOptions/selection-options/send`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: selectionOptionsStatusUpdateRequest,
    },
    options,
  );
};

export const getSelectionOptionsSelectionOptionsSendPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationKey = ["selectionOptionsSelectionOptionsSendPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionOptionsSelectionOptionsSendPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionOptionsSelectionOptionsSendPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>
  >;
export type SelectionOptionsSelectionOptionsSendPutV2MutationBody =
  BodyType<SelectionOptionsStatusUpdateRequest>;
export type SelectionOptionsSelectionOptionsSendPutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Sends a list of draft selection options by transitioning them to PENDING (displayed as "Sent"),
making the options visible to clients in the client portal.
 */
export const useSelectionOptionsSelectionOptionsSendPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>,
    TError,
    { data: BodyType<SelectionOptionsStatusUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionOptionsSelectionOptionsSendPutV2>>,
  TError,
  { data: BodyType<SelectionOptionsStatusUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionOptionsSelectionOptionsSendPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
